(function () {
  function loadAccessiBe() {
    var s = document.createElement('script');
    var h = document.querySelector('head') || document.body;
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    s.async = true;
    s.onload = function () {
      acsbJS.init({
        statementLink: '',
        footerHtml: '',
        hideMobile: false,
        hideTrigger: true,
        disableBgProcess: false,
        language: 'en',
        position: 'left',
        leadColor: '#000000',
        triggerColor: '#146ff8',
        triggerRadius: '50%',
        triggerPositionX: 'right',
        triggerPositionY: 'bottom',
        triggerIcon: 'people',
        triggerSize: 'medium',
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: 'small',
          triggerPositionX: 'right',
          triggerPositionY: 'bottom',
          triggerOffsetX: 10,
          triggerOffsetY: 10,
          triggerRadius: '50%',
        },
      });
    };
    h.appendChild(s);
  }

  // Lazy load on interaction
  var loaded = false;
  function onInteraction() {
    if (loaded) return;
    loaded = true;
    // Use requestIdleCallback if available, or setTimeout as fallback
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadAccessiBe);
    } else {
      setTimeout(loadAccessiBe, 200);
    }
    // Remove listeners
    window.removeEventListener('mousemove', onInteraction);
    window.removeEventListener('scroll', onInteraction);
    window.removeEventListener('touchstart', onInteraction);
    window.removeEventListener('keydown', onInteraction);
  }

  window.addEventListener('mousemove', onInteraction, { passive: true, once: true });
  window.addEventListener('scroll', onInteraction, { passive: true, once: true });
  window.addEventListener('touchstart', onInteraction, { passive: true, once: true });
  window.addEventListener('keydown', onInteraction, { passive: true, once: true });
})();
